import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { forwardRef, type ChangeEvent, type ReactNode } from "react";
import type { MessageSendingInputStyle } from "./types";
import styles from "./styles.module.css";

interface Props {
  sendValue: string;
  actions: React.ReactNode;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  inputStyle?: MessageSendingInputStyle;
  extraContent?: ReactNode;
  inputPlaceholder?: string;
  onPaste?: (e: React.ClipboardEvent) => void;
  handleKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  isDisabled?: boolean;
  className?: string;
  inputClassName?: string;
  actionWrapperClassName?: string;
}

export const MessageSendingInput = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      sendValue,
      actions,
      onChange,
      handleKeyDown,
      rows,
      inputStyle = "standard",
      extraContent,
      onPaste,
      inputPlaceholder,
      isDisabled,
      className,
      inputClassName,
      actionWrapperClassName,
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const placeholder = inputPlaceholder
      ? inputPlaceholder
      : t("chat_modal.message_input_placeholder");
    const clsContainer = classNames(
      styles["wrapper-zone"],
      extraContent && styles["extra-zone"],
      className,
    );
    const clsInputWrapper = classNames(
      styles["send-block"],
      styles[`message-input-${inputStyle}`],
      isDisabled && styles["input-disabled"],
    );
    const clsInput = classNames(styles["chat-input"], inputClassName);
    const clsActionsWrapper = classNames(
      styles["actions-wrapper"],
      actionWrapperClassName,
    );

    return (
      <div className={clsContainer}>
        {extraContent}
        <div className={clsInputWrapper}>
          <textarea
            ref={ref}
            value={sendValue}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            rows={rows}
            onPaste={onPaste}
            placeholder={placeholder}
            className={clsInput}
            disabled={isDisabled}
          />
          <div className={clsActionsWrapper}>{actions}</div>
        </div>
      </div>
    );
  },
);
